<template >
  <!--
    SLOTS:
      bottom

    SLOTS-PASS-THROUGH:
      empty
      tableHeader
      normal
  -->
  <div class="table-v2-custom" :class="[themeClass(), {'table-v2-custom--responsive': responsive}]">
    <div class="table-v2-inner-spacing">
      <!--Global component-->
      <component v-bind:is="tableComponent"
        :externalFiltering="externalFiltering"
        :data="data"
        :default-sort="sort"
        @sort-change="clickHandler"
        :hoverOverlayComponent="hoverOverlayComponent"
        :bottomOverlayComponent="bottomOverlayComponent"
        :sort="sort"
        :overlayColumnStart="overlayColumnStart"
        :rowKey="rowKey"
        :refreshTable="refreshTable"
        ref="table">

        <template slot='empty'>
          <slot name="empty"></slot>
        </template>

        <template slot='loading'>
          <slot name="loading"></slot>
        </template>

        <template slot='tableHeader'>
          <slot name="tableHeader"></slot>
        </template>

        <!-- insert your table columns here -->
        <slot></slot>

      <!-- </v2-section-table> -->
      </component>
      <slot name="bottom"></slot>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { V2Table } from './index'
Vue.use(V2Table)

const TABLE_TYPES = {
  V2_TABLE: 1,
  V2_SECTION_TABLE: 2
}

export default {
  // TODO change the data and defaultSort methods to a object and bind that object to the v2-table
  // that object will have the same interface as the v2-table component
  // TODO sort these out when you need to
  props: {
    // V-2 TABLE Props
    data: Array,
    hoverOverlayComponent: String,
    bottomOverlayComponent: String,
    externalFiltering: Function,
    sort: Object,
    overlayColumnStart: Number,
    // STYLE TABLE props
    theme: {
      type: String,
      default: 'dark'
    },
    responsive: {
      type: Boolean,
      default: true
    },
    lazyLoad: Boolean,
    tableType: {
      type: Number,
      default: TABLE_TYPES.V2_TABLE
    },
    rowKey: String,
    refreshTable: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    table () {
      return this.$refs.table
    },
    tableComponent () {
      if (this.tableType === TABLE_TYPES.V2_TABLE) {
        return 'v2-table'
      } else if (this.tableType === TABLE_TYPES.V2_SECTION_TABLE) {
        return 'v2-section-table'
      } else {
        return 'v2-table'
      }
    }
  },
  methods: {
    themeClass () {
      return `table-v2-custom--${this.theme}-theme`
    },
    clickHandler (sort) {
      this.$emit('sort-change', sort)
    }
  }
}

</script>

<style lang="scss">
.table-v2-custom {
  height: 100%;

  .table-v2-inner-spacing {
    margin:0 10px 0 10px;
    height: 100%;
  }

  &--responsive {
    .v2-table {
      &__header-wrapper {
        width: 100% !important;
      }
      &__body-wrapper {
        width: 100% !important;
      }
      &__footer-wrapper {
        width: 100% !important;
      }
    }
  }

  &--orange-theme {
    $header-color: #8F8F8F;
    $primary-color: #DFDFDF;
    $secondary-color: #BFBFBF;
    $hover-over-color: #AFAFAF;
    $text-color: black;
    height: 100%;
    background: $primary-color;

    .empty-dashboard {
      background:  $primary-color;
    }

    .v2-table {
      // TODO need to only have the color in here
      &__header-dashboard{
        position: relative;
        z-index: $z-10;
        display: flex;
        align-items: center;
        align-content: space-between;
        height: 70px;
        background: $header-color;
      }

      &__cell.v2-table__column-cell {
        background: $primary-color;
        border-bottom: none;
        text-transform: uppercase;
        color: $text-color;
      }

      &__cell.v2-table__row-cell {
        color: $text-color;
        border-bottom: none;
      }
      &__row {
        font-size: 16px;

        &:nth-child(2n + 1) {
          background: $secondary-color;
        }

        &:nth-child(2n) {
          background: $primary-color;
        }

        &:hover {
          background-color: $hover-over-color;
        }

        &--active.targets-table__target-row--active {
          background-color: $hover-over-color;
        }
      }
    }
  }

  &--dark-theme {
    $primary-color: color(blue-grey, light);
    background: $primary-color;
    height: 100%;

    .empty-dashboard {
      background:  $primary-color;
    }
    // overrides
    .v2-table {

      &__cell.v2-table__column-cell {
        background: $primary-color;
        border-bottom: none;
        text-transform: uppercase;
        color: color(grays, extra-light);
      }

      &__header-dashboard{
        position: relative;
        z-index: $z-10;
        display: flex;
        align-items: center;
        align-content: space-between;
        height: 70px;
        background: color(blue-grey, very-dark);
      }

      &__cell.v2-table__row-cell {
        color: white;
        border-bottom: none;
      }
      &__row {
        font-size: 16px;

        &:nth-child(2n + 1) {
          background: color(blue-grey, dark);
        }

        &:nth-child(2n) {
          background: $primary-color;
        }

        &:hover {
          background-color: rgb(48,54,61);
        }

        &--active.targets-table__target-row--active {
          background-color: rgb(48,54,61);
        }
      }
    }
  }
}

.row_hover_overlay__background {
  background:  rgba(0, 0, 0, 0.75);
}

</style>



// WEBPACK FOOTER //
// StyledTable.vue?ede38b8e